import React, { useState } from 'react';
import './textInput.scss';

interface ITextInputProps {
    value?: string;
    onChange?: (_: any) => void;
    onBlur?: (_: any) => void;
    onFocus?: (_: any) => void;
    placeholder?: string;
    classes?: string;
    'data-testid'?: string;
    prefix?: string;
}

const TextInput = ({
    value = '',
    onChange,
    onBlur,
    onFocus,
    placeholder,
    classes,
    'data-testid': dataTestId,
    prefix,
}: ITextInputProps) => {
    const [_value, setValue] = useState(value);

    const _handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;

        setValue(value);

        if (onChange) {
            onChange(value);
        }
    };

    return (
        <div className={classes}>
            <div className="lean-eds-textinput">
                {prefix && (
                    <span className="lean-eds-textinput__text-prefix">
                        {prefix}
                    </span>
                )}
                <input
                    type="text"
                    className="lean-eds-textinput__input"
                    value={_value}
                    onChange={_handleOnChange}
                    onBlur={onBlur}
                    onFocus={onFocus}
                    placeholder={placeholder}
                    data-testid={dataTestId}
                />
            </div>
        </div>
    );
};

export default TextInput;
